export const PaymentStatus = {
    결제대기: "결제대기",
    입금대기: "입금대기",
    결제완료: "결제완료",
    취소대기: "취소대기",
    환불완료: "환불완료",
    결제실패: "결제실패",
    결제취소: "결제취소",
} as const;

export const OrderType = {
    구독권: "구독권",
    스토어: "스토어",
    토큰: "토큰",
    포인트: "포인트",
    검사도구: "검사도구",
} as const;

export const TossPaymentStatus = {
    /// 결제를 생성하면 가지게 되는 초기 상태입니다. 인증 전까지는 READY 상태를 유지합니다.
    READY: "READY",

    /// 결제수단 정보와 해당 결제수단의 소유자가 맞는지 인증을 마친 상태입니다. 결제 승인 API를 호출하면 결제가 완료됩니다.
    IN_PROGRESS: "IN_PROGRESS",

    /// 가상계좌 결제 흐름에만 있는 상태로, 결제 고객이 발급된 가상계좌에 입금하는 것을 기다리고 있는 상태입니다.
    WAITING_FOR_DEPOSIT: "WAITING_FOR_DEPOSIT",

    /// 인증된 결제수단 정보, 고객 정보로 요청한 결제가 승인된 상태입니다.
    DONE: "DONE",

    /// 승인된 결제가 취소된 상태입니다.
    CANCELED: "CANCELED",

    /// 승인된 결제가 부분 취소된 상태입니다.
    PARTIAL_CANCELED: "PARTIAL_CANCELED",

    /// 결제 승인이 실패한 상태입니다.
    ABORTED: "ABORTED",

    /// 결제 유효 시간 30분이 지나 거래가 취소된 상태입니다. IN_PROGRESS 상태에서 결제 승인 API를 호출하지 않으면 EXPIRED가 됩니다.
    EXPIRED: "EXPIRED",
} as const;

export const TossPaymentStatusKoreanMap = {
    READY: "결제대기",
    IN_PROGRESS: "결제진행중",
    WAITING_FOR_DEPOSIT: "입금대기",
    DONE: "결제완료",
    CANCELED: "결제취소",
    PARTIAL_CANCELED: "부분취소",
    ABORTED: "결제실패",
    EXPIRED: "결제만료",
} as const;

export const PaymentType = {
    NORMAL: "일반결제",
    BILLING: "자동결제",
    BRANDPAY: "브랜드페이",
} as const;
